import dispatch from './dispatch';

export const trackCarouselClickEvent = ({
  page,
  carousel,
  isForward = null,
  type,
  index,
}) => {
  const eventName = 'carouselClick';
  const detail = {
    eventInfo: {
      eventAction: 'Carousel Click',
      eventName: 'carouselClick',
      eventType: 'userEvent',
      event: {
        component: 'carousel',
        navLocation: page,
        nextsliderArrow: isForward,
        prevsliderArrow: isForward === null ? null : !isForward,
        selectedNavItem: `${carousel}|${type}`,
        sliderNum: index,
        category: 'navigation',
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};
